@if (invoices?.length > 0) {
  <div [class.configuration-container]="showContainer" [class.mt-4]="showContainer" [class.forceDefaultColors]="showContainer" [class.invoices--embedded]="!showContainer">
    <div class="invoices">
      @if (showTitle) {
        <h1 class="mb-4">{{ 'settings.invoicesAndReceipts' | translate }}</h1>
      }
      @for (invoice of invoices; track invoice.id) {
        @if (invoice.status != 'creating' && (invoice.price > 0 || invoice.type === InvoiceTypeEnum.Api)) {
          <div class="invoices__list">
            <div class="invoices__list-item" [ngClass]="[statusClass(invoice.status), isMobileRowClickable(invoice) ? 'clickable' : '']" (click)="onMobileRowClick(invoice)">
              <div class="invoices__product">
                <div class="invoices__product-name">{{ invoice.description }}</div>
                <div class="invoices__product-meta">
                  <button class="monster__badge badge-XS" [ngClass]="'badge-' + idBadgeVariant(invoice.status)" role="button" ngxClipboard [cbContent]="invoice.id" (click)="copyInvoiceId()">
                    <span class="invoice-id-label">ID :</span>
                    <span class="invoice-id-value">{{ invoice.id }}</span>
                    <i class="far fa-copy invoice-id-icon"></i>
                  </button>
                  <div class="invoices__product-date">{{ invoice.due_date | ldate: 'mediumDate' }}</div>
                </div>
              </div>
              @if (!isMobile) {
                <div>
                  <span class="monster__badge badge-M" [ngClass]="'badge-' + statusBadge(invoice.status)">
                    <i class="far" [ngClass]="statusIcon(invoice.status)"></i>{{ 'status_' + invoice.status | translate }}
                  </span>
                </div>
              }
              <div class="invoices__value">
                <span class="currencyCode invoices__currency-code">{{ currencyCode(invoice.currency) }}</span
                >{{ invoice.price / 100 | lcurrency }}
              </div>
              @if (!isMobile) {
                <div class="buttons">
                  @if (invoiceUrl(invoice)) {
                    <button class="btn-S btn-filled" (click)="openUrl(invoiceUrl(invoice))">
                      {{ 'settings.accessInvoice' | translate }}
                    </button>
                  }
                  @if (canShowReceipt(invoice)) {
                    <div appDropdown placement="bottom-right">
                      <button type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-end" appDropdownToggle>
                        <span>{{ 'settings.receipt' | translate }}</span>
                        <i class="fa-regular fa-chevron-down dropdown__toggle-chevron"></i>
                      </button>
                      <div appDropdownMenu>
                        <button type="button" appDropdownItem (click)="openUrl(nfseUrl(invoice))">
                          <i class="fa-regular fa-file-arrow-down"></i>
                          {{ 'settings.download' | translate }} PDF
                        </button>
                        <button type="button" appDropdownItem (click)="openUrl(nfseUrl(invoice, 'xml'))">
                          <i class="fa-regular fa-file-arrow-down"></i>
                          {{ 'settings.download' | translate }} XML
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (isMobileRowClickable(invoice)) {
                <div class="invoices__mobile-arrow">
                  <i class="fas fa-chevron-right"></i>
                </div>
              }
            </div>
          </div>
        }
      }
      @if (!isLoading && !isLastPage) {
        <div class="more">
          <button type="button" class="autentique-button autentique-button--edit" (click)="onLoadMore()">{{ 'button.loadMore' | translate }}</button>
        </div>
      }
    </div>
  </div>
}
